import React, { useMemo, useState, useEffect } from 'react';

// Данный компонент необходим для изменения высоты контейнера для графиков в дашбордах
// в зависимости от того, показываются лэйблы или нет

const ChartWrapper = ({ unit, height, children, setChart: setChartFromProps }) => {
  const [chart, setChart] = useState(null);

  useEffect(() => {
    if (chart) {
      setChartFromProps(chart);
    }
  }, [chart, setChartFromProps]);

  useMemo(() => {
    if (chart) {
      // получаем элемент-контейнер графика и применяем к нему высоту из props
      const styleChartWrapper = document.querySelector(
        `[data-id = chart-wrapper_${unit?.id}]`
      )?.style;
      styleChartWrapper.height = height;

      // setTimeout нужен для того, чтобы необходимые элементы отобразились/удалились из DOM
      // и правильно рассчиталась высота контейнера и графика
      setTimeout(() => {
        chart.setSize(null, null);
      }, 0);
    }
  }, [chart, height, unit?.id]);

  return (
    <>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          setChart,
        })
      )}
    </>
  );
};

export default ChartWrapper;
